module.exports = __webpack_public_path__ + "static/media/wired-logo.2ad37b94.svg";